import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { Roles } from 'src/app/shared/services/names.service';

@Injectable({
  providedIn: 'root'
})
export class CprRoleGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {

  }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
      const currentRole = await this.authService.getUserRoles()
      if(currentRole === Roles.cprUser || currentRole === Roles.adminUser)
      return true
    else {
      this.router.navigate(['/forbidden'])
      return false
    }
  }

}
